import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TagsComponent } from './components/tags/tags.component';
import { Observable, combineLatest } from 'rxjs';
import { Store } from '@ngrx/store';
import { CONVERSATION_DATA_REDUCER, IConversationDataState } from '../../store/reducers/conversation-data.reducer';
import { AsyncPipe } from '@angular/common';
import { EHttpErrorStatus } from '../../core/configurations/errors';
import { AlertComponent } from '../../shared/components/alert/alert.component';
import { AccordionModule } from 'primeng/accordion';
import { ConversationDetailsComponent } from './components/conversation-details/conversation-details.component';
import { RouterLink } from '@angular/router';
import { IScorecardState, SCORECARD_REDUCER } from '../../store/reducers/scorecard.reducer';
import { ScorecardPreviewComponent } from './components/scorecard-preview/scorecard-preview.component';
import { ContactDetailsComponent } from './components/contact-details/contact-details.component';
import { LeasingPreferencesComponent } from './components/leasing-preferences/leasing-preferences.component';
import { AppointmentDetailsComponent } from './components/appointment-details/appointment-details.component';
import { CampaignDetailsComponent } from './components/campaign-details/campaign-details.component';
import { SkeletonModule } from 'primeng/skeleton';
import { HasContentPipe } from './pipes/has-content.pipe';
import { IScorecardPreview } from '../../shared/models/scorecard-preview.model';
import { ReprocessingToolsComponent } from './components/reprocessing-tools/reprocessing-tools.component';
import { CLAIMS_REDUCER } from '../../store/reducers/claims.reducer';
import { EClaimName } from '../../core/configurations/claims';

@Component({
  selector: 'cv-conversation-data',
  standalone: true,
  imports: [
    TagsComponent,
    AsyncPipe,
    AlertComponent,
    AccordionModule,
    ConversationDetailsComponent,
    ScorecardPreviewComponent,
    RouterLink,
    ContactDetailsComponent,
    LeasingPreferencesComponent,
    CampaignDetailsComponent,
    AppointmentDetailsComponent,
    SkeletonModule,
    HasContentPipe,
    ReprocessingToolsComponent,
  ],
  templateUrl: './conversation-data.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationDataComponent {
  readonly EHttpErrorStatus = EHttpErrorStatus;
  readonly data$: Observable<IConversationComponentData> = combineLatest({
    conversationDetails: this.store.select<IConversationDataState>(
      CONVERSATION_DATA_REDUCER.selectConversationDataState,
    ),
    scorecard: this.store.select<IScorecardState>(SCORECARD_REDUCER.selectScorecardState),
    disqualifiedScorecard: this.store.select(SCORECARD_REDUCER.selectDisqualifiedScorecardPreviews(true)),
    qualifiedScorecard: this.store.select(SCORECARD_REDUCER.selectDisqualifiedScorecardPreviews(false)),
    hasACEInsightsAdminClaim: this.store.select(CLAIMS_REDUCER.has(EClaimName.aceInsightsAdmin)),
  });

  constructor(private readonly store: Store) {}
}

export interface IConversationComponentData {
  conversationDetails: IConversationDataState;
  scorecard: IScorecardState;
  disqualifiedScorecard: IScorecardPreview[];
  qualifiedScorecard: IScorecardPreview[];
  hasACEInsightsAdminClaim: boolean;
}
